var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import classnames from 'classnames';
var CordataTable = function CordataTable(_ref) {
  var striped = _ref.striped,
    highlight = _ref.highlight,
    className = _ref.className,
    showAll = _ref.showAll,
    data = _ref.data,
    showPagination = _ref.showPagination,
    minRows = _ref.minRows,
    props = _objectWithoutProperties(_ref, ['striped', 'highlight', 'className', 'showAll', 'data', 'showPagination', 'minRows']);
  var classes = classnames({
    '-striped': striped,
    '-highlight': highlight
  }, className);
  return React.createElement(ReactTable, _extends({
    className: classes,
    pageSize: showAll ? data.length : undefined,
    minRows: showAll ? data.length : minRows,
    data: data,
    showPagination: showAll || showPagination,
    showPageJump: false
  }, props));
};
CordataTable.propTypes = {
  striped: PropTypes.bool,
  highlight: PropTypes.bool,
  className: PropTypes.string,
  showAll: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  showPagination: PropTypes.bool,
  minRows: PropTypes.number
};
CordataTable.defaultProps = {
  striped: true,
  highlight: true,
  className: undefined,
  showAll: false,
  data: [],
  showPagination: true,
  minRows: 0
};
export default CordataTable;